import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { LoginPage } from './features/auth/components/LoginPage';
import { VerifyPage } from './features/auth/components/VerifyPage';
import { PacketPage } from './features/packet/pages/PacketPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './features/auth/context/AuthContext';
import { ProtectedRoute } from './features/auth/components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';
import { AcceptInvitationPage } from './features/invitations/AcceptInvitationPage';
import { GlobalInvitationsPage } from './features/invitations/GlobalInvitationsPage';
import { AttestInvitationPage } from './features/invitations/AttestInvitationPage';
import { DashboardPage } from './pages/DashboardPage';
import { Navbar } from './components/Navbar';
import { PacketListPage } from './features/packet/pages/PacketListPage';
import InsightsPage from './pages/InsightsPage';
import { navigationService } from './services/navigation';
import { useEffect } from 'react';

// Inner component that has access to the router context
function AppContent() {
  const navigate = useNavigate();

  // Register the navigate function with the navigation service on mount
  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return (
    <>
      <Navbar />
      <Routes>
        <Route 
          path="/" 
          element={
            <ProtectedRoute redirectTo="/login">
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        {/* Inviter management view */}
        <Route
          path="/management"
          element={
            <ProtectedRoute>
              <GlobalInvitationsPage />
            </ProtectedRoute>
          }
        />
        {/* Peer attestation view (anonymous) */}
        <Route
          path="/invitations/attest"
          element={<AttestInvitationPage />}
        />
        {/* Invitee accepts invitation */}
        <Route path="/invitations/:token" element={<AcceptInvitationPage />} />
        {/* Deep links for endorsement and assessment on PacketPage */}
        <Route 
          path="/packets/new" 
          element={
            <ProtectedRoute>
              <PacketPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/packets/:packetId/*" 
          element={
            <ProtectedRoute>
              <PacketPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/packets" 
          element={
            <ProtectedRoute>
              <PacketListPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/insights" 
          element={<InsightsPage />} 
        />
      </Routes>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
